import { render } from "./Histlist.vue?vue&type=template&id=2ce4b063"
import script from "./Histlist.vue?vue&type=script&lang=js"
export * from "./Histlist.vue?vue&type=script&lang=js"

import "./Histlist.vue?vue&type=style&index=0&id=2ce4b063&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__